// extracted by mini-css-extract-plugin
export default {"container":"content_container__lQNY4","children":"content_children__c5NgF"};